<template>
  <section>
    <div class="container">
      <div class="row row-cols-auto justify-content-center my-3">
        <div class="col-md-3 d-flex flex-row flex-wrap justify-content-start bg-dark-light align-items-center py-4 ps-5 border-left-radius">
          <div
            v-for="region in regions"
            :key="region.RegionName"
            class="me-2 d-flex align-self-center"
            @click="selectRegion(region.RegionEngName)"
          >
            <h5 class="fw-normal mb-0">
              <div
                class="
                  badge
                  rounded-pill
                  bg-none
                  text-dark
                  fw-normal
                "
                :class="{'bg-success text-white':isEqualToCurrentRegion(region.RegionEngName)}"
              >
                {{ region.RegionName }}
              </div>
            </h5>
          </div>
        </div>
        <div class="col-md-9 d-flex flex-row flex-wrap bg-light justify-content-center  align-items-center border-right-radius ">
          <div
            v-for="city in currentCities.Cities"
            :key="city.CityEngName"
            class="me-2 d-flex align-self-center"
            @click="selectCity(city)"
          >
            <h5 class="fw-normal mb-0">
              <div
                class="
                  badge
                  rounded-pill
                  bg-none
                  text-dark
                  fw-normal
                "
                :class="{'bg-white':isEqualToCityName(currentCity.CityEngName,city.CityEngName)}"
              >
                {{ city.CityName }}
              </div>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, computed, watch } from 'vue'
import citiesData from '@/assets/Cities.json'
export default {
  name: 'RegionSelect',
  components: {
  },
  emits: ['selectCity'],
  setup (props, { emit }) {
    const currentRegion = ref('northern')

    const regions = computed(() => citiesData.map((city) => {
      return {
        RegionName: city.RegionName,
        RegionEngName: city.RegionEngName
      }
    }))

    const selectRegion = (region) => {
      currentRegion.value = region
    }

    const isEqualToCurrentRegion = (region) => {
      return currentRegion.value === region
    }

    const isEqualToCityName = (currentCity, city) => {
      return currentCity === city
    }

    const currentCities = computed(() => citiesData.filter((city) => city.RegionEngName === currentRegion.value)[0])
    const currentCity = ref({})
    watch(currentCities, (newValue) => {
      if (newValue) {
        currentCity.value = newValue.Cities[0]
      }
    }, { immediate: true })

    const selectCity = (city) => {
      currentCity.value = city
    }
    watch(currentCity, (newValue) => {
      if (newValue) {
        emit('selectCity', newValue)
      }
    }, { immediate: true })

    return {
      selectRegion,
      selectCity,
      currentRegion,
      currentCities,
      currentCity,
      regions,
      isEqualToCurrentRegion,
      isEqualToCityName
    }
  }
}
</script>

<style lang="scss" scoped>
.badge{
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 75px;
  line-height: 25px;
  padding: 0 1.5rem;
  &.active {
  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    bottom: .35rem;
    width: .85rem;
    height: 4px;
    border-radius: 6px;
    background-color:  #10CC9F;
    transform:translate(-50%,0);
  }
  }
}

.icon{
  width: 1.45rem;
  transform: translateX(-.75rem);
}

.bg-dark-light{
  background:  #F2F2F2;
  border-right:1px solid #DEDEDE;
  position: relative;
   &::before {
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: -1rem;
    top: 50%;
    transform: translateY(-50%);
    content: "";
    background-image: url("../assets/image/Polygon.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.border-left-radius{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.border-right-radius{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
</style>
